import { useState } from "react";
import Logo from "./Logo";

const navLinks = [
  { label: "Laman Utama", href: "#beranda" },
  { label: "Tentang Kami", href: "#tentang" },
  { label: "Program", href: "#program" },
  { label: "Sumbangan", href: "#sumbangan" },
  { label: "Hubungi Kami", href: "#hubungi" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Logo variant="dark" />

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#sumbangan"
              className="ml-3 px-5 py-2.5 rounded-full bg-accent-500 text-foreground-950 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-accent-400 transition-colors"
            >
              Derma Sekarang
            </a>
          </nav>

          {/* Mobile hamburger */}
          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer text-foreground-900"
            aria-label="Menu"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-lg text-foreground-700 font-medium cursor-pointer hover:bg-primary-50 hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#sumbangan"
              onClick={() => setOpen(false)}
              className="mt-2 px-4 py-3 rounded-lg bg-accent-500 text-foreground-950 font-semibold text-center cursor-pointer hover:bg-accent-400 transition-colors"
            >
              Derma Sekarang
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}